import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickApiInput from '@/components/brick_api_input.vue'

let infos = new BrickInfos()

infos.input = '   '
infos.back_classes = ['fas', 'fa-square', 'text-green']
infos.front_classes = ['fas', 'far fa-brackets-curly', 'text-white']
infos.name = 'api_input'
infos.associated_class_name = 'AutomlApiInput'
infos.editing_component_name = 'BrickApiInput'
infos.editing_component = BrickApiInput
infos.summary_component_name = ''
infos.summary_component = undefined
infos.element_preview_type = 'JsonViewer'
infos.descriptions = {
  en: {
    short_tooltip_description: 'API Input',
    full_tooltip_description: 'Get data through API connection',
    navbar_name: 'API Input',
  },
  fr: {
    short_tooltip_description: 'Entrée API',
    full_tooltip_description:
      'Récupération de données grâce à la connexion API',
    navbar_name: 'Entrée API',
  },
}
// infos.short_tooltip_description = 'api_input_short_tooltip'
// infos.full_tooltip_description = 'api_input_full_tooltip'
// infos.navbar_name = 'api_input_navbar'
infos.background_color = 'green'

brick_registerer(infos)
